<template>
  <!-- Google Captcha  -->
  <div class="modal fade custom-modal verify-modal" id="goog-cap">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content Set-google-capt">
        <div class="captcha-header d-flex align-items-center justify-content-between">
          <h4>Configure Google Captcha</h4>
          <span>
            <a href="">
              <i class="feather-x"></i>
            </a>
          </span>
        </div>
        <div class="modaled-body">
          <form action="#">
            <label>Google Rechaptcha Site Key <span> * </span></label>
            <input type="text" class="form-control" />
            <label>Google Rechaptcha Secret Key <span> * </span></label>
            <input type="text" class="form-control" />
          </form>
        </div>
        <div class="acc-submited">
          <button type="submit" class="btn btn-primary">Submit</button>
          <button
            type="submit"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            :aria-label="$t('close')"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- /Google Captcha  -->

  <!-- Agora Captcha  -->
  <div class="modal fade custom-modal verify-modal" id="agora-cap">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content Set-google-capt">
        <div class="captcha-header d-flex align-items-center justify-content-between">
          <h4>Agora Settings</h4>
          <span>
            <a href="">
              <i class="feather-x"></i>
            </a>
          </span>
        </div>
        <div class="modaled-body">
          <form action="#">
            <label>Agora Application key <span> * </span></label>
            <input type="text" class="form-control" />
            <label>APNS Key <span> * </span></label>
            <input type="text" class="form-control" />
          </form>
        </div>
        <div class="acc-submited">
          <button type="submit" class="btn btn-primary">Submit</button>
          <button
            type="submit"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            :aria-label="$t('close')"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- /Agora Captcha  -->

  <!-- Agora Captcha  -->
  <div class="modal fade custom-modal verify-modal" id="fire-cap">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content Set-google-capt">
        <div class="captcha-header d-flex align-items-center justify-content-between">
          <h4>Firebase Settings</h4>
          <span>
            <a href="">
              <i class="feather-x"></i>
            </a>
          </span>
        </div>
        <div class="modaled-body">
          <form action="#">
            <label>Firebase Server Key<span> * </span></label>
            <input type="text" class="form-control" />
            <label>APNS Key <span> * </span></label>
            <input type="text" class="form-control" />
          </form>
        </div>
        <div class="acc-submited">
          <button type="submit" class="btn btn-primary">Submit</button>
          <button
            type="submit"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            :aria-label="$t('close')"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- /Agora Captcha  -->
</template>
